import React, { Component } from "react";
import Functions from "../../src/functions";
import ModalWidget from "./templates/modal";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      main: [],
      header: [],
      loaded: false,
    };
  }

  componentDidMount() {
    this.setState({ loaded: true });
    let UserType = Functions["custom"]["getUserType"]();
    let landPageData = JSON.parse(sessionStorage.landPageData);
    if (
      UserType === "POSTB" ||
      UserType === "POSTB_SPLIT" ||
      UserType === "POSTR"
    ) {
      if (landPageData.contractInfoCarrier.inListOfWhatuspCss) {
        Functions.addCSS("/resources/prepaid/css/style-post.css");
        Functions.addCSS("/resources/css/jquery.jscrollpane.css");
        Functions.addCSS("/resources/prepaid/css/mobile-post.css");
        Functions.addCSS("/resources/css/custom.css");
        Functions.addCSS("/resources/prepaid/css/whatsupPost.css");
      } else {
        Functions.addCSS("/resources/css/style.css");
        Functions.addCSS("/resources/css/jquery.jscrollpane.css");
        Functions.addCSS("/resources/css/mobile.css");
        Functions.addCSS("/resources/css/custom.css");
      }
      Functions.addScript("/resources/js/jquery-1.8.3.min.js");
      Functions.addScript("/resources/js/jquery.backstretch.min.js");
      Functions.addScript("/resources/js/jquery.easing.1.3.js");
      Functions.addScript("/resources/js/jquery.jscrollpane.min.js");
      Functions.addScript("/resources/js/jquery.mousewheel.js");
      Functions.addScript("/resources/js/jquery.nicescroll.min.js");
      Functions.addScript("/resources/js/dlp.libraries.1.0.js");
      Functions.addScript("/resources/js/deeplink.js");
      Functions.addScript("/resources/js/remote-logger.js");
      Functions.addScript("/resources/js/mwheelIntent.js");
      Functions.addScript("/resources/js/main.js");
      Functions.addScript("/resources/js/dlp.main.1.0.js");
    } else if (
      UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
      landPageData.contractInfoCarrier.inListOfWhatuspCss
    ) {
      Functions.addCSS("/resources/prepaid/css/style-cc.css");
      Functions.addCSS("/resources/prepaid/css/jquery.jscrollpane.css");
      Functions.addCSS("/resources/prepaid/css/mobile-cc.css");
      Functions.addCSS("/resources/prepaid/css/rebranding.css");
      Functions.addCSS("/resources/prepaid/css/whatsupCC.css");
      Functions.addCSS("/resources/prepaid/css/custom.css");
      // Functions.addCSS("/resources/hybrid_wallets/css/style.css");
      // Functions.addCSS("/resources/hybrid_wallets/css/jquery.jscrollpane.css");
      // Functions.addCSS("/resources/hybrid_wallets/css/mobile.css");
      // Functions.addCSS("/resources/hybrid_wallets/css/whatsup.css");
      //Functions.addCSS("/resources/hybrid_wallets/css/hybrid-wallet-whatsup.css");

      Functions.addScript("/resources/prepaid/js/jquery-1.8.3.min.js");
      Functions.addScript("/resources/js/dlp.libraries.1.0.js");
      Functions.addScript("/resources/prepaid/js/dlp.prepaid.main.1.0.js");
      Functions.addScript("/resources/prepaid/js/jquery.easing.1.3.js");
      Functions.addScript("/resources/prepaid/js/jquery.backstretch.min.js");
      Functions.addScript("/resources/prepaid/js/jquery.mousewheel.js");
      Functions.addScript("/resources/prepaid/js/mwheelIntent.js");
      Functions.addScript("/resources/prepaid/js/jquery.jscrollpane.min.js");
      Functions.addScript("/resources/prepaid/js/main.js");
      Functions.addScript("/resources/prepaid/js/jquery.nicescroll.min.js");
      Functions.addScript("/resources/js/deeplink.js");
      Functions.addScript("/resources/js/remote-logger.js");
    } else {
      Functions.addCSS("/resources/prepaid/css/style.css");
      Functions.addCSS("/resources/prepaid/css/jquery.jscrollpane.css");
      if (UserType === "PREPAID_WHATSUP")
        Functions.addCSS("/resources/prepaid/css/whatsup.css");
      // Functions.addCSS("/resources/prepaid/css/rebranding.css");
      Functions.addScript("/resources/prepaid/js/jquery-1.8.3.min.js");
      Functions.addScript("/resources/js/dlp.libraries.1.0.js");
      Functions.addScript("/resources/prepaid/js/dlp.prepaid.main.1.0.js");
      Functions.addScript("/resources/prepaid/js/jquery.easing.1.3.js");
      Functions.addScript("/resources/prepaid/js/jquery.backstretch.min.js");
      Functions.addScript("/resources/prepaid/js/jquery.mousewheel.js");
      Functions.addScript("/resources/prepaid/js/mwheelIntent.js");
      Functions.addScript("/resources/prepaid/js/jquery.jscrollpane.min.js");
      Functions.addScript("/resources/prepaid/js/main.js");
      Functions.addScript("/resources/js/deeplink.js");
      Functions.addScript("/resources/js/remote-logger.js");
      Functions.addCSS("/resources/prepaid/css/mobile.css");
      Functions.addCSS("/resources/prepaid/css/custom.css");

      // Functions.addScript("/resources/prepaid/js/jquery.nicescroll.min.js");
      // Functions.addScript("/resources/prepaid/js/scroller.js");
      // Functions.addScript("/resources/prepaid/js/modernizr.custom.js");
    }
  }

  render() {
    if (this.state.loaded) {
      return (
        <div id="wrapper" className="wrapper" style={{ minHeight: "1255px;" }}>
          {this.state.main}
          <ModalWidget
            ref={(refComponent) => {
              window["modal"] = refComponent;
            }}
          ></ModalWidget>
          <ModalWidget
            ref={(refComponent) => {
              window["modal2"] = refComponent;
            }}
          ></ModalWidget>
        </div>
      );
    }
    return "";
  }
}

export default Index;
